export default "__VITE_ASSET__BBDJGmaN__"